module.exports = __webpack_public_path__ + "img/ic_whats_new.4d03cfb3.svg";